export default "__VITE_ASSET__DW4s$Ka$__"